import { get } from 'lodash'

import { joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'Routing',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      routingGroups: undefined
    }
  },

  watch: {
    value: {
      handler() {
        this.getRoutingGroups()
      },
      deep: true
    }
  },

  mounted() {
    this.getRoutingGroups()
  },

  methods: {
    async getRoutingGroups() {
      const OwnerId = get(this.value, 'Owner.id', this.value.OwnerId)
      if (OwnerId) {
        try {
          const data = await request.get(joinURLPath('users', OwnerId), undefined, { $scope: [ 'RoutingGroups' ] })
          if (data && data.RoutingGroups && Array.isArray(data.RoutingGroups) && data.RoutingGroups.length) {
            this.routingGroups = data.RoutingGroups.reduce((result, { id, type, title }) => {
              if (!result[type]) {
                result[type] = []
              }
              result[type].push({
                id,
                type,
                title
              })

              return result
            }, {})
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    }
  },

  render
}
